<template>
    <div>
        <div v-if="is_super_admin" style="padding: 10px 16px;">
            <el-table
                :data="lDeviceList"
                style="width: 100%;border-color:'#606266'"
                :default-sort = "{prop: 'date', order: 'descending'}"
                :header-cell-style="{background:'#f8f8f8', fontFamily:'Helvetica',fontSize:'14px'}"
                :cell-style="{color: '#666',fontSize:'14px'}"
                border
            >

            <el-table-column
                fixed
                align="center"
                prop="device_auto_id"
                label="设备自增ID"
                sortable
                >
            </el-table-column>

            <el-table-column
                fixed
                align="center"
                prop="device_name"
                label="设备名称"
                >
            </el-table-column>

            <el-table-column
                fixed
                align="center"
                prop="device_id"
                label="设备ID"
                >
            </el-table-column>

            <el-table-column
                fixed
                align="center"
                prop="device_enter_time"
                label="设备录入时间"
                >
            </el-table-column>

            <el-table-column
                fixed
                align="center"
                label="所属关系"
                >
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.room_id">包间 ID:{{ scope.row.room_id }}</el-tag>
                    <el-tag v-else>店铺 ID:{{ scope.row.shop_id }}</el-tag>
                </template>
            </el-table-column>

            <el-table-column
                fixed
                align="center"
                prop="device_enter_time"
                label="所属名称"
                >
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.room_id">{{ scope.row.room_name }}</el-tag>
                    <el-tag v-else>{{ scope.row.shop_name }}</el-tag>
                </template>
            </el-table-column>

            <el-table-column
                fixed
                align="center"
                prop="device_type"
                label="设备类型"
                >
                <template slot-scope="scope">
                    <el-tag type="info" v-if="scope.row.device_type == 0">门锁</el-tag>
                    <el-tag type="info" v-else-if="scope.row.device_type == 1">Switch断路器Zigbee</el-tag>
                    <el-tag type="info" v-else-if="scope.row.device_type == 2">空调红外</el-tag>
                    <el-tag type="info" v-else-if="scope.row.device_type == 3">智能开关Zigbee</el-tag>
                    <el-tag type="info" v-else-if="scope.row.device_type == 4">智能插座Zigbee</el-tag>
                    <el-tag type="info" v-else-if="scope.row.device_type == 5">智能空开Zigbee</el-tag>
                    <el-tag type="info" v-else-if="scope.row.device_type == 6">室内应急灯(Switch)</el-tag>
                    <el-tag type="danger" v-else>错误的设备</el-tag>
                </template>
            </el-table-column>

            <el-table-column
                    align="center"
                    label="操作"
                    width="200px"
                >
                <template slot-scope="scope">
                    <el-button round icon="el-icon-delete" type="danger" size="small" @click="deleteFunc(scope.row)">删除</el-button>
                    <!-- <el-button round plain icon="el-icon-delete" type="success" size="small" @click="editFunc(scope.row)">编辑</el-button> -->
                </template>
            </el-table-column>

            </el-table>

            <el-pagination
            @current-change="changeCurrent"
            :current-page="iCurrentPage"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="iMaxTotal"
            style="text-align:right; margin-top:15px"
            >
            </el-pagination>

        </div>
        <div v-else>
            <div style="text-align: center;">
                <div style="margin-top: 0px;">
                <img src="../assets/permission_denied.png">
                <div style="margin-top: 20px;">
                    <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: "DeviceSystem",
    data(){
        return {
            sDialogName: '',
            bShowDialog: false,
            sBtnName: '',
            bShowFullscreen: false,
            bRequestType: true,
            lDeviceList: [],
            iCurrentPage: 1,
            iMaxTotal: 10,
            is_super_admin: false,
            
        }
    },

    mounted(){
        // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
        let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
        if (isSuperAdmin == "false") {
            this.is_super_admin = false
            return
        } else {
        this.is_super_admin = true
        }
        this.getDeviceList()
    },

    methods: {

        // 获取设备列表
        async getDeviceList(){
            let url = '/api/device/'
            let params = {
                'page': this.iCurrentPage,
                'page_size': 10,
            }
            let res = await this.$axios.get(url, {params: params})
            
            this.lDeviceList = res.data.results;
            this.iMaxTotal = res.data.count;
        },

        // 分页器触发事件
        changeCurrent(val){
            this.iCurrentPage = val
            this.getDeviceList()
        },

        // 删除设备
        deleteFunc(row){
            var _this = this
            this.$confirm('此操作将永久删除该设备', '删除消息警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                _this.$axios.delete('/api/device/' + row.device_auto_id + '/').then(
                function(res){_this.$message({type: 'success', message: '删除成功!'});
                _this.getDeviceList()})
            }).catch(() => {
                _this.$message({type: 'info',message: '已取消删除'});          
            });
            
        },

    }
}
</script>